module.exports = __webpack_public_path__ + "static/media/image02.fd14ef58.png";